import React from 'react';
import './Dropdown.scss';

const Dropdown = props => {
  const { items, clickEventHandler } = props;
  const selectedIndexArray = [];

  const handleSelectedIndex = (selected, depthLevel) => {
    selectedIndexArray[depthLevel] = selected;
  };

  const renderSubMenu = (options, depthLevel = 0) => {
    const menuOptions = options.map((option, index) => {
      const display = option.options ? (
        <div onMouseEnter={() => handleSelectedIndex(index, depthLevel)}>
          <a
            className='dropdown-toggle dropdown-item'
            data-toggle='dropdown-submenu'
          >
            {option.icon && (
              <img className='imgLogo' src={option.icon} alt={option.alt} />
            )}
            <span className='socialMediaTxt'>{option.name}</span>{' '}
          </a>
        </div>
      ) : (
        <div
          onClick={() => {
            handleSelectedIndex(index, depthLevel);
            clickEventHandler(selectedIndexArray.slice(0, depthLevel + 1));
          }}
          onKeyPress={() => {
            handleSelectedIndex(index, depthLevel);
            clickEventHandler(selectedIndexArray.slice(0, depthLevel + 1));
          }}
          role='button'
          tabIndex={0}
        >
          <a className='dropdown-item'>
            {option.icon && (
              <img className='imgLogo' src={option.icon} alt={option.alt} />
            )}

            <span className='socialMediaTxt'>{option.name}</span>
          </a>
        </div>
      );
      let subMenu;
      if (option.options && option.options.length > 0) {
        const newDepthLevel = depthLevel + 1;
        subMenu = renderSubMenu(option.options, newDepthLevel);
      }
      const subMenuContainer = subMenu ? (
        <div className='dropdown-menu'>{subMenu}</div>
      ) : (
        ''
      );
      return (
        <div className='dropdown-submenu' key={option.id}>
          {display}
          {subMenuContainer}
        </div>
      );
    });
    return <div>{menuOptions}</div>;
  };

  return <div className='dropdown-menu'>{renderSubMenu(items)}</div>;
};

export default Dropdown;
